import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu, SelectedMenuContent } from 'rangeConfig/@types';
import ChangeOrientation from 'rangeConfig/knoxhult/widgets/ChangeOrientation';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import {
  matchDimensions,
  matchOrientation,
  matchType
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import { canSelectedEntityBeMirrored } from 'rangeConfig/shared/rules/hideMenuRules';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';
import removeHandleFromSelectedEntity from 'rangeConfig/shared/behaviors/removeHandleFromSelectedEntity';
import { colorFilter, handlesTypeFilter } from 'rangeConfig/shared/filters/configFilters';
import { dragAndDropHandlesBehavior } from 'rangeConfig/shared/behaviors/dragAndDropHandlesBehavior';
import { showDoors } from 'ducks/layout';
import autoFillHandles from 'rangeConfig/shared/behaviors/autoFillHandles';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    {
      id: 'change-orientation',
      component: ChangeOrientation,
      hidden: (coreApi: CoreApi) => canSelectedEntityBeMirrored(coreApi)
    },
    {
      id: 'frames-selected-menu-frames',
      title: 'storageone.frontStyleTabTitle',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.ENHET_WALL_FRAME
      ],
      noThumbs: () => true,
      productFilters: [matchDimensions, matchType, matchOrientation]
    }
  ],
  mobile: [
    {
      id: 'frames-selected-menu-change-orientation',
      title: 'storageone.changeOrientation',
      component: ChangeOrientation,
      hidden: (coreApi: CoreApi) => canSelectedEntityBeMirrored(coreApi)
    },
    {
      id: 'frames-selected-menu-frames',
      title: 'storageone.frontStyleTabTitle',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM
      ],
      noThumbs: () => true,
      productFilters: [matchDimensions, matchType, matchOrientation]
    },
    {
      id: 'frames-selected-menu-handles',
      title: 'storageone.productListHandlesTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      behaviors: {
        productClicked: [showDoors, autoFillHandles],
        productDropped: [dragAndDropHandlesBehavior]
      },
      productTypes: [ProductType.HANDLE, ProductType.KNOB, ProductType.EDGE_HANDLE],
      filters: [handlesTypeFilter, colorFilter],
      productFilters: [],
      noneOption: {
        behaviors: { removeProducts: [removeHandleFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([
          ProductType.HANDLE,
          ProductType.KNOB,
          ProductType.EDGE_HANDLE
        ]),
        title: 'storageone.productListNoHandlesOptionTitle',
        subtitle: 'storageone.productListNoHandlesOptionSubtitle'
      }
    },
    {
      id: 'frames-selected-menu-sinks',
      title: 'storageone.sinks',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',

      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [ProductType.KITCHEN_SINK_ASM],
      filters: [],
      productFilters: [],
      noneOption: {
        behaviors: { removeProducts: [removeHandleFromSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([
          ProductType.HANDLE,
          ProductType.KNOB,
          ProductType.EDGE_HANDLE
        ]),
        title: 'storageone.productListNoHandlesOptionTitle',
        subtitle: 'storageone.productListNoHandlesOptionSubtitle'
      }
    }
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.productListCustomiseCabinetsTitle',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform] as SelectedMenuContent[]
};

export default selectedMenu;
